module.exports = __webpack_public_path__ + "static/media/service1.f042b73b.png";